import { parse } from 'query-string'
import { useMemo } from 'react'
import { useLocation } from 'react-router'

export function useQueryParams<T>() {
  const { search } = useLocation()

  return useMemo(
    () => parse(search, { arrayFormat: 'comma', parseBooleans: true }) as T,
    [search]
  )
}
